import { CustomEventListener } from "./CustomEventListener";
import { CustomEvent } from "./CustomEvent";
import { BaseEventDispatcher } from "./BaseEventDispatcher";

export class CustomEventDispatcher implements BaseEventDispatcher
{
    private customEventListeners: Array<CustomEventListener> = [];

    public addEventListener(type: string, listener: Function, arg: any = null): void
    {
        if (this.checkHasListener(type, listener))
        {
            return;
        }
        this.customEventListeners.push(new CustomEventListener(type, listener, arg));
    }

    public removeEventListener(type: string, listener: Function): void
    {
        for (let i: number = 0; i < this.customEventListeners.length; i++)
        {
            if (this.customEventListeners[i].listener === listener && this.customEventListeners[i].type === type)
            {
                this.customEventListeners.splice(i, 1);
                return;
            }
        }
    }

    public checkHasListener(type: string, listener: Function): boolean
    {
        for (var i: number = 0, l: number = this.customEventListeners.length; i < l; i++)
        {
            if (this.customEventListeners[i].type === type && this.customEventListeners[i].listener === listener)
            {
                return true;
            }
        }
        return false;
    }

    public dispatchEvent(event: CustomEvent): void
    {
        event.target = this;
        let listeners: Array<CustomEventListener> = this.customEventListeners.slice(0);
        for (let i: number = 0; i < listeners.length; i++)
        {
            if (listeners[i].type === event.type)
            {
                listeners[i].listener.call(listeners[i].arg, event);
            }
        }
    }
}
